<form class="mce-form-section">

    <div class="mce-form-section-title">Installation & Current Capacity </div>


    @if(viewState().showForm) {

    <div class="mce-form-field-group">

        <div class="flex-grow" [class.mce-form-field-disabled]="standardsRx.isLoading()">
            <mat-form-field class="w-full">
                <mat-label>sizing standard</mat-label>
                <mat-select [formField]="form().installation.standardGuid">
                    @for (option of standards(); track option.guid) {
                    <mat-option [value]="option.guid">{{option.reference}}: {{option.title}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>circuit length, m</mat-label>
                <input matInput type="number" placeholder="circuit length, m"
                       [formField]="form().installation.circuitLength" />
                <span matSuffix>m</span>
                @for (error of form().installation.circuitLength().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        @if(viewState().showSingleCoreArrangement) {
        <app-single-core-arrangement [form]="form()"></app-single-core-arrangement>
        }


        @if(viewState().showUDRFactors) {
        <app-factors-udr [form]="form().installation.udrFactors"></app-factors-udr>
        }

        @if(viewState().showBS7671Factors) {
        <app-factors-bs7671 [form]="form()"></app-factors-bs7671>
        }

        @if(viewState().showERA6930P3Factors) {
        <app-factors-era6930p3 [form]="form()"></app-factors-era6930p3>
        }

        @if(viewState().showERA6930P5Factors) {
        <app-factors-era6930p5 [form]="form()"></app-factors-era6930p5>
        }

        @if(viewState().showIEC60502P2Factors) {
        <app-factors-iec60502p2 [form]="form()"></app-factors-iec60502p2>
        }

    </div>

    }

    <app-capacity-calculation
        [installation]="form().installation" [systemVoltage]="form().systemVoltage" [load]="form().load"
        [protection]="form().protection" [selectedCable]="form().selectedCable"
        [settings]="form().settings">
    </app-capacity-calculation>

</form>
